import { ChallengeShippingAddress } from '../../../../types/challenges';
import { AddressLineOneField, FormGroup } from '../../../common';
import CountrySelect from '../../../common/CustomSelect/CountrySelect/CountrySelect';
import { getLocationDetails } from '../../../../services/dashboard.service';
import { handleAddressInputChange } from '../../../../utils/validations';
import useIsMobile from '../../../../hooks/useIsMobile';
import styles from './claimRewardModal.module.css';

type ShippingAddressStepProps = {
  address: Required<Omit<ChallengeShippingAddress, 'phone'>>;
  setAddress: React.Dispatch<React.SetStateAction<Required<Omit<ChallengeShippingAddress, 'phone'>>>>;
};

export default function ShippingAddressStep({ address, setAddress }: ShippingAddressStepProps) {
  const isMobile = useIsMobile();
  const fontSize = '14px';
  const labelFontSize = isMobile ? '12px' : '14px';

  const handleFetchLocation = async (zipcode: string) => {
    const data = await getLocationDetails(zipcode);
    setAddress((prev) => ({
      ...prev,
      city: data?.city || prev.city,
      state: data?.state || prev.state,
      country: data?.country || prev.country,
    }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleAddressInputChange(e, setAddress, handleFetchLocation);
  };

  return (
    <div className={styles.addressForm}>
      <AddressLineOneField
        label="Address"
        placeholder="e.g. Empire State Building"
        value={address.addressLineOne}
        onChange={handleInputChange}
        required
        className="p-0"
        fontSize={fontSize}
        labelFontSize={labelFontSize}
      />
      <div className={styles.addressRow}>
        <FormGroup
          id="addressLineTwo"
          name="addressLineTwo"
          label="Apartment, suite, etc"
          type="text"
          placeholder="e.g. 10th floor"
          value={address.addressLineTwo}
          onChange={handleInputChange}
          className="p-0"
          fontSize={fontSize}
          labelFontSize={labelFontSize}
        />
        <FormGroup
          id="pincode"
          name="pincode"
          label="Postal Code"
          type="text"
          placeholder="e.g. 10001"
          value={address.pincode}
          onChange={handleInputChange}
          required
          className="p-0"
          fontSize={fontSize}
          labelFontSize={labelFontSize}
        />
      </div>
      <FormGroup
        id="city"
        name="city"
        label="City"
        type="text"
        placeholder="e.g. New York"
        value={address.city}
        onChange={handleInputChange}
        required
        className="p-0"
        fontSize={fontSize}
        labelFontSize={labelFontSize}
      />
      <FormGroup
        id="state"
        name="state"
        label="State"
        type="text"
        placeholder="e.g. New York"
        value={address.state}
        onChange={handleInputChange}
        required
        className="p-0"
        fontSize={fontSize}
        labelFontSize={labelFontSize}
      />
      <CountrySelect
        value={address.country}
        setValue={(value: string) => setAddress((prev) => ({ ...prev, country: value }))}
        wrapperClassName={styles.countrySelect}
      />
    </div>
  );
}
